import React from 'react';
import { Button } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useBack } from 'modules/global';

type PropsType = {
  countdown: number | null;
};

const FinalStep: React.FC<PropsType> = ({ countdown }) => {
  const t = useTranslations();
  const onBack = useBack('/');

  return (
    <>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div className="item-center w-100 flex flex-col justify-center">
          <div className="flex items-center justify-center">
            <Image
              src="/images/tick.webp"
              alt="tick"
              width={257}
              height={257}
              title="Ro'yxatdan o'tingiz"
              loading="lazy"
            />
          </div>
          <h2 className="mb-4 text-center text-2xl font-semibold">{t('auth.last_step_title')} 🎉</h2>
          <p className="mb-4 text-center text-gray-600">{t('auth.last_step_desc')}</p>
          <Button
            onClick={onBack}
            className="!w-full !rounded-md !rounded-xl !border-transparent !bg-green-500 !py-5 !text-white"
          >
            {t('davom_ettirish')}
          </Button>
        </div>
      </div>
      {countdown !== null && (
        <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-gray-800 px-2 py-1 text-sm text-white">
          {countdown}s
        </div>
      )}
    </>
  );
};

export default FinalStep;
